/* --------------------------------------------------------------------------------------
   printTests.service.js
   Copyright © 2018 Xerox Corporation. All Rights Reserved.

   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

export default class printTestsService {
  /*@ngInject*/
  constructor (appService, dataService, printService, jobStatusService) {
    this.appService = appService
    this.dataService = dataService
    this.printService = printService

    this.jobStatusService = jobStatusService
  }
  printTests() {
    return this.dataService.postPrintTests(
      this.appService.classId,
      this.appService.testId,
      this.appService.answerKey? 'true':'false',
      this.appService.selectedStudentIds
    )
    .then((result) => {
      this.appService.init()
      return this.printService.submitPrint(result.ReportGuid)
        .then(result => this.jobStatusService.getPrintFinishedStatus(result))
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/printTests/services/printTests.service.js